import API from "../../services/api";
import { setStoredAccessToken } from "../../utils/authSession";
import { normalizeApiError } from "../../utils/normalizeApiError";

export const loginUser = async (username, password) => {
  const form = new URLSearchParams();
  form.append("username", username);
  form.append("password", password);

  const { data } = await API.post("/auth/login", form);
  if (data?.access_token) setStoredAccessToken(data.access_token);
  return data;
};

export const registerUser = async (payload) => {
  try {
    const { data } = await API.post("/auth/register", payload);
    return data;
  } catch (err) {
    throw new Error(normalizeApiError(err));
  }
};

export const forgotPassword = async (email, { accountType = "admin", portal = "client" } = {}) => {
  const path =
    accountType === "employee"
      ? "/employee-auth/forgot-password"
      : "/auth/forgot-password";
  const body = accountType === "employee" ? { email } : { email, portal };
  const { data } = await API.post(path, body);
  return data;
};

export const getProfile = async () => {
  const { data } = await API.get("/users/me");
  return data;
};

export const updateMyProfile = async (payload) => {
  const { data } = await API.patch("/users/me", payload);
  return data;
};

export const sendRegistrationEmailOtp = async (email) => {
  try {
    const { data } = await API.post("/auth/register/send-email-otp", { email });
    return data;
  } catch (err) {
    throw new Error(normalizeApiError(err));
  }
};

export const verifyRegistrationEmailOtp = async (email, otp) => {
  try {
    const { data } = await API.post("/auth/register/verify-email-otp", { email, otp });
    return data;
  } catch (err) {
    throw new Error(normalizeApiError(err));
  }
};